const decodeHtml = (html) => {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

const ReadingMixedComponent = (params) => {
  return `
  <li class="o-articleList__item">
    <div class="m-article">
      <a href="${params.link}">
        <div class="m-article__img">
          <img src="${params.image}">
        </div>
        <div class="m-article__content">
          <p class="m-article__text">
              ${params.category ? `<span class="m-article__category">${decodeHtml(params.category)}</span><br>` : ''}
            ${decodeHtml(params.title)}
          </p>
        </div>
      </a>
    </div>
  </li>
  `;
};



const normalizeShopifyPosts = (posts) => {
  return posts.map(item => ({
    ...item,
    published_at: new Date(item.published_at),
  }));
};

const renderReadingList = () => {
  const list = document.getElementById('reading-list');
  if (!list) return;

  const posts = normalizeShopifyPosts(window.shopifyBlogPosts || [])
    .sort((a, b) => b.published_at - a.published_at)
    .slice(0, 4);

  list.innerHTML = posts.map(item => ReadingMixedComponent(item)).join('');

  initReadingIndicators();
};
document.addEventListener('DOMContentLoaded', renderReadingList);

function initReadingIndicators() {
  if (window.innerWidth >= 768) return;

  const section = document.querySelector('.p-top__section.-reading');
  if (!section) return;

  const slider = section.querySelector('.o-articleList.-fes-slider');
  const indicatorsContainer = section.querySelector('.slider-indicators');
  if (!slider || !indicatorsContainer) return;

  const items = slider.querySelectorAll('.o-articleList__item');
  const totalPages = items.length; // 1列なのでアイテム数＝ページ数

  if (totalPages <= 1) return;

  // ドット生成
  indicatorsContainer.innerHTML = '';
  for (let i = 0; i < totalPages; i++) {
    const dot = document.createElement('div');
    dot.classList.add('indicator-dot');
    if (i === 0) dot.classList.add('active');

    dot.addEventListener('click', function() {
      slider.scrollTo({ left: slider.offsetWidth * i, behavior: 'smooth' });
    });

    indicatorsContainer.appendChild(dot);
  }

  // スクロールでアクティブドット更新
  slider.addEventListener('scroll', function() {
    const currentPage = Math.round(slider.scrollLeft / slider.offsetWidth);
    indicatorsContainer.querySelectorAll('.indicator-dot').forEach(function(dot, index) {
      dot.classList.toggle('active', index === currentPage);
    });
  });
}